export default {
  label: {
    search: '検索',
    require: '必須',
    create: '新規作成',
    logout: 'ログアウト',
    yen: '円',
    action: 'アクション',
    confirm_title: '確認',
    from: 'から',
    to: 'まで',
    time: '倍',
  },
  button: {
    search: '検索',
    create: '新規作成',
    register: '登録',
    edit: '修正',
    detail: '詳細',
    delete: '削除',
    complete: '完了',
    cancel: 'キャンセル',
    discancel: 'キャンセル解除',
    yes: 'はい',
    no: 'いいえ',
    next: '次へ',
    close: '閉じる',
    back: '戻る',
    confirm: '確認',
    logout: 'ログアウト',
    login: 'ログイン',
    ok: 'OK',
    reset: 'リセット',
    sure: '確定',
    clear: 'クリア',
    select: '確定',
    tempolary: '一時保存',
    migration: '売上連携',
  },
  message: {},
  menu_items: {
    top: 'ホーム',
    estimates_search: '見積管理',
    projects: '商流管理',
    schedules: 'スケジュール管理',
    schedules_sale: '営業用',
    schedules_car_manager: '配車課・環境管理部用',
    calendar_settings: 'カレンダ設定',
    job_daily_management: '作業日報管理',
    daily_work_report_list: '作業日報登録',
    daily_work_report_approval_search: '作業日報承認',
    daily_work_report_maintenance_search: '作業日報メンテナンス',
    manifest_management: 'マニフェスト管理',
    inquiry_management: 'お問合せ管理',
    inquiry: '設定',
    calendar_settings_reservation_date_selection: '予約日選択用カレンダ設定',
    system_setting: 'システム設定',
  },
  pages: {
    project: {
      work_instruction: {
        title: "作業指示詳細"
      },
      sale: {
        contract: {
          treatment: "処分契約詳細",
          transport: "収集運搬契約詳細"
        }
      }
    }
  },
  sub_pages: {
    0: '廃棄物一覧', //waste
    1: 'サービス一覧', // work
    2: '見積一覧', // estimate
    3: '契約一覧', // contract
    4: '作業指示一覧', // instruction
  },
  navbar: {
    dropdown: {
      logout: 'ログアウト',
      logoutIdP: 'ログアウト(GMOトラストログインへ)',
      "notification": {
        "text": "Notifications",
        "subtext": "View All",
        "order": {
          "title": "Your order is placed",
          "text": "If several languages coalesce the grammar",
          "time": "3 min ago"
        },
        "james": {
          "title": "James Lemire",
          "text": "It will seem like simplified English.",
          "time": "1 hours ago"
        },
        "item": {
          "title": "Your item is shipped",
          "text": "If several languages coalesce the grammar",
          "time": "3 min ago"
        },
        "salena": {
          "title": "Salena Layfield",
          "text": "As a skeptical Cambridge friend of mine occidental.",
          "time": "1 hours ago"
        },
        "button": "View More.."
      },
      "profile": {
        "text": "Peter",
        "list": {
          "welcome": "Welcome Peter!",
          "profile": "Profile",
          "messages": "Messages",
          "taskboard": "Taskboard",
          "help": "Help",
          "balance": {
            "text": "Balance",
            "amount": "$1901.67"
          },
          "settings": {
            "text": "Settings",
            "badge": "New"
          },
          "lockscreen": "Lock screen",
          "logout": "Logout"
        }
      }
    },
    "search": {
      "text": "Search..."
    },
  }
};
